import { useState, useEffect } from 'react';
import { getReps } from '@services/repService';

/** All published reps for a lesson, in position order — used for prev/next navigation. */
export const useReps = (lessonId) => {
  const [reps, setReps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getReps(lessonId)
      .then(data => { if (!cancelled) setReps(data); })
      .catch(() => { if (!cancelled) setReps([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [lessonId]);

  return { reps, loading };
};

export default useReps;
